import * as t from 'io-ts';
import { optional } from './helper';
import { status } from './score';

const player = t.type({
  playerId: t.string,
  shortName: t.string,
  fullName: t.string,
});
export type Player = t.TypeOf<typeof player>;

const scorecardTeam = t.type({
  name: t.string,
  shortName: t.string,
  logoFull: t.string,
  teamId: t.string,
  players: t.array(player),
});
export type ScorecardTeam = t.TypeOf<typeof scorecardTeam>;

const umpireOfficial = t.type({
  firstName: t.string,
  initials: t.string,
  lastName: t.string,
});

const umpire = t.type({
  onField: t.array(umpireOfficial),
  referee: t.array(umpireOfficial),
});

const toss = t.type({
  description: t.string,
});

const scorecardVenue = t.type({
  location: t.string,
});

const dismissal = t.type({
  id: t.number,
  name: t.string,
});

const batter = t.type({
  balls: t.number,
  fours: t.number,
  isBatting: t.boolean,
  playerId: t.string,
  reasonShort: t.string,
  runs: t.number,
  sixes: t.number,
  strikeRate: t.string,
  dismissal,
});
export type Batter = t.TypeOf<typeof batter>;

const bowler = t.type({
  economy: optional(t.number),
  maidens: t.number,
  overs: t.number,
  runs: t.number,
  wickets: t.number,
  wides: t.number,
  playerId: t.string,
});
export type Bowler = t.TypeOf<typeof bowler>;

const fallOfWicket = t.type({
  batsmanId: t.string,
  order: t.number,
  overs: t.number,
  runs: t.number,
});
export type FallOfWicket = t.TypeOf<typeof fallOfWicket>;

const extras = t.type({
  byes: t.number,
  legByes: t.number,
  noBalls: t.number,
  penalties: t.number,
  total: t.number,
  wides: t.number,
});

const inning = t.type({
  batters: t.array(batter),
  battingTeamId: t.string,
  bowlers: t.array(bowler),
  extras,
  fallOfWickets: optional(t.array(fallOfWicket)),
  isDeclared: t.boolean,
  isFollowOn: t.boolean,
  isForfeited: t.boolean,
  isEliminator: t.boolean,
  overs: t.number,
  runs: t.number,
  wickets: t.number,
  no: t.number,
});
export type Inning = t.TypeOf<typeof inning>;

const win = t.type({
  teamId: optional(t.string),
});

const scorecardMatchState = t.type({
  day: t.number,
  days: t.number,
  description: t.string,
  innings: t.number,
  isDls: t.boolean,
  remainingOvers: optional(t.number),
  win: optional(win),
});

const scorecard = t.type({
  homeTeamId: t.string,
  innings: t.array(inning),
  matchState: scorecardMatchState,
  teams: t.tuple([scorecardTeam, scorecardTeam]),
  toss,
  umpire,
  venue: scorecardVenue,
});

export const cricketScorecard = t.type({
  scorecard,
  eventDateStart: t.string,
  eventDateEnd: t.string,
  eventName: t.string,
  seriesTitle: t.string,
  status,
  subStatus: status,
  gameType: status,
  tourTitle: t.string,
});
export type CricketEvent = t.TypeOf<typeof cricketScorecard>;
